import { Link } from "react-router-dom";
import { MapPin, Clock, Users, Star } from "lucide-react";
import WishlistButton from "./WishlistButton";
import ShareWhatsAppButton from "./ShareWhatsAppButton";

export default function TourCard({ tour }) {
  const priceLabel = `${tour.duration} · ₹${tour.price.toLocaleString("en-IN")} per person`;
  return (
    <div className="block group relative">
      <div className="absolute top-4 right-4 z-10 flex gap-2">
        <WishlistButton tourId={tour.id} />
        <ShareWhatsAppButton
          title={tour.title}
          subtitle={priceLabel}
          path={`/tours/${tour.id}`}
          testId={`share-btn-${tour.id}`}
        />
      </div>
      <Link to={`/tours/${tour.id}`} className="block">
        <div className="bg-white rounded-2xl overflow-hidden border border-[#E5DDCB] card-lift">
          <div className="relative img-zoom aspect-[4/3]">
            <img src={tour.image} alt={tour.title} className="w-full h-full object-cover" />
            <div className="absolute top-4 left-4 bg-[#C87A50] text-white text-xs uppercase tracking-widest font-semibold px-3 py-1 rounded-full">
              {tour.tag}
            </div>
            <div className="absolute bottom-4 right-4 bg-white/95 rounded-full px-3 py-1 flex items-center gap-1 text-xs font-semibold text-[#1F4D3A]">
              <Star className="w-3.5 h-3.5 fill-[#C9A961] text-[#C9A961]" />
              {tour.rating} <span className="text-[#6B8E5A]">({tour.reviews})</span>
            </div>
          </div>
          <div className="p-5 sm:p-6">
            <div className="flex items-center gap-2 text-[#6B8E5A] text-[10px] sm:text-xs uppercase tracking-widest font-semibold mb-2">
              <MapPin className="w-3.5 h-3.5" />
              {tour.location}
            </div>
            <h3 className="font-serif text-xl sm:text-2xl font-semibold text-[#1F4D3A] mb-2 group-hover:text-[#C87A50] transition-colors leading-tight">
              {tour.title}
            </h3>
            <p className="text-sm text-[#5A4A38] leading-relaxed mb-4 sm:mb-5 line-clamp-2">{tour.short}</p>
            <div className="flex items-center gap-4 text-xs text-[#5A4A38] mb-4 sm:mb-5 pb-4 sm:pb-5 border-b border-[#E5DDCB]">
              <span className="flex items-center gap-1.5"><Clock className="w-3.5 h-3.5 text-[#C87A50]" /> {tour.duration}</span>
              <span className="flex items-center gap-1.5"><Users className="w-3.5 h-3.5 text-[#C87A50]" /> {tour.groupSize}</span>
            </div>
            <div className="flex items-end justify-between">
              <div>
                <span className="text-[10px] sm:text-[11px] text-[#6B8E5A] uppercase tracking-wider">Starting</span>
                <p className="font-serif text-xl sm:text-2xl font-bold text-[#1F4D3A] leading-none">₹{tour.price.toLocaleString('en-IN')}</p>
                <span className="text-[10px] sm:text-[11px] text-[#5A4A38]">per person</span>
              </div>
              <span className="text-sm font-semibold text-[#C87A50] group-hover:translate-x-1 transition-transform inline-block">
                View →
              </span>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}
